<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium">
            {{ $t('BOOKING.RESOURCES.ITEM') }}
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn dark color="indigo" @click="$router.go(-1)">
          {{ $t('BUTTON.BACK') }}
        </v-btn>

        <v-btn
          class="ml-2"
          color="primary"
          @click="
            $router.push({
              name: 'booking-resources.edit',
              params: { id: id }
            })
          "
        >
          {{ $t('BUTTON.EDIT') }}
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </v-card>

    <v-card class="mt-3">
      <v-card-text>
        <v-form v-model="valid">
          <booking-resource-form v-model="form" readonly />
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import BookingResourceForm from '../components/forms/BookingResourceForm.vue';

export default {
  name: 'BookingResourceShowPage',

  components: {
    BookingResourceForm
  },

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => {
    return {
      valid: false,
      form: {}
    };
  },

  mounted() {
    this.getBookingResource({ resourceId: this.id }).then(({ data }) => {
      this.form = data;
    });
  },

  methods: {
    ...mapActions('booking_resources', ['getBookingResource'])
  }
};
</script>
